import React from 'react';
import { pdf } from '@react-pdf/renderer';
import CourseCertificate from '../../components/CourseCertificate';
import { User } from '../../types/User';
import courseService from '../../services/course.service';
import { CourseRegistration } from '@kimuno/api-sdk/lib/types/responses/CourseRegistration';
import services from '../../services';
import { CertificateDownloaded } from '../../ampli';
import { getAmpliContentData } from '../../utils/ampli';

export const generateCertificatePDF = async (
  user: User | undefined,
  mindItemId: string,
) => {
  if (!user) {
    return;
  }

  const courseRegistration = await courseService.getCourseRegistration(mindItemId);    

  if (!courseRegistration.certifiedAt || !courseRegistration.isCompleted || !courseRegistration.isPassed) {
    return;
  }

  const document = (
    <CourseCertificate
      userName={`${user.firstName} ${user.lastName}`}
      title={courseRegistration.mindItem.title}
      duration={courseRegistration.mindItem.course.duration}
      theme={courseRegistration.mindItem.course.theme}
      certifiedAt={courseRegistration.certifiedAt}
    />
  );

  trackCertificateDownload(courseRegistration);
  const blob = await pdf(document).toBlob();
  return URL.createObjectURL(blob);
};

export const trackCertificateDownload = (courseRegistration: CourseRegistration) => {
  const eventProperties = {
    content: getAmpliContentData({ ...courseRegistration.mindItem, id: courseRegistration.mindItemId }, 'mindItem'),
  };

  services.track.ampliEventTrack({ 
    event: new CertificateDownloaded(eventProperties)
  });   
};
